/* Aug 2026 (Joe/Claude): homepage-only JS, loaded alongside homepage-polish.css
   (see that file for why homepage-specific tweaks live outside theme.js/
   theme.css.liquid) — for the one fix on this page that genuinely can't be
   done with CSS alone: centring the Judge.me reviews trust bar's vertical
   divider on the page.

   Background: Joe wants the divider between "4.9 ★★★★★" and "4.9 out of 5
   stars based on 2601 reviews" to line up with the header logo (and the
   spanner icon in the trust row below it), i.e. true page centre — not just
   the midpoint of the rating+text group as a block. The two sides of the
   divider are different widths ("4.9 ★★★★★" ~213px vs "4.9 out of 5
   stars..." ~272px), so simply centring the group as a block puts the
   divider off true centre by ~20-30px.

   First attempt solved this with pure CSS (equal flex: 1 1 0 halves of a
   full-width row), which does put the divider exactly on centre, but at the
   cost of stretching each half to 50% of the ENTIRE section width — since
   the actual content is much narrower than that, it left large, obviously
   empty gaps on the outer edges (worst on the right, after the text ends).
   Joe flagged this as a new problem.

   There's no pure-CSS way to centre a boundary between two unequal,
   auto-sized elements on an external reference point without either
   stretching the container (the problem above) or hardcoding a guessed
   pixel width for content that can change (review count digits, in
   particular). So instead: measure the live positions of the logo and the
   divider, and shift the whole compact, naturally-sized rating+text group
   sideways by exactly the difference. Nothing is resized, so no new empty
   space is introduced — the group just slides left/right until the divider
   sits under the logo's centre. Re-measured on load, on resize (viewport
   width and logo position both change at breakpoints), and once more after
   a short delay as a fallback in case the reviews app block or web font
   renders after the initial checks (same pattern used for the product
   carousel's nav-arrow state elsewhere on this page). */
(function () {
  var MOBILE_BREAKPOINT = 750; // matches the @media rules in homepage-polish.css

  function centerReviewsDivider() {
    var group = document.querySelector(
      '[id$="__173922228579a03ec7"] .jdgm-all-reviews-text > a'
    );
    var textEl = document.querySelector(
      '[id$="__173922228579a03ec7"] .jdgm-all-reviews-text__text'
    );
    var logo = document.querySelector(
      '.site-header__logo-link, .site-header__logo'
    );

    if (!group || !textEl || !logo) return;

    // Below the mobile breakpoint the rating and text stack onto two lines
    // (Judge.me's own stylesheet switches to flex-direction: column here),
    // so there's no single horizontal divider to centre — reset any
    // transform from a previous wider viewport and stop.
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      group.style.transform = '';
      return;
    }

    // Reset before measuring so repeated calls (e.g. on resize) compute a
    // fresh delta from the untranslated layout rather than compounding.
    group.style.transform = '';

    var dividerX = textEl.getBoundingClientRect().left; // divider = this span's own border-left, at its box edge
    var logoRect = logo.getBoundingClientRect();
    var targetX = logoRect.left + logoRect.width / 2;
    var delta = targetX - dividerX;

    group.style.transform = 'translateX(' + delta + 'px)';
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(centerReviewsDivider, 100);
  }

  centerReviewsDivider();
  window.addEventListener('load', centerReviewsDivider);
  window.addEventListener('resize', onResize);
  // Fallback in case the Judge.me widget or web fonts finish rendering
  // after 'load' has already fired.
  setTimeout(centerReviewsDivider, 1000);
})();
